module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "db centered-container-ns"
  }, [_c('div', {
    staticClass: "bg-white ph3 ph4-ns mt6 mt0-ns pv5-ns br2-ns border-login",
    attrs: {
      "id": "login-card"
    }
  }, [_c('h1', {
    staticClass: "f3 lh-copy fw3 tc"
  }, [_vm._v(_vm._s(_vm.$t('login.title', {
    title: 'Customer Login'
  })))]), _vm._v(" "), (_vm.loginMessage.message) ? _c('div', {
    staticClass: "dark-red f6 mt4 tc br2 ba b--dark-red pa2"
  }, [_vm._v(_vm._s(_vm.loginMessage.message))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "mv4"
  }, [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "number"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.phone', {
    phone: 'Cell Phone Number'
  }))), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputMask', {
    staticClass: "input-reset ba border-login pa2 mb2 db w-100 br2",
    attrs: {
      "id": "number",
      "type": "tel",
      "mask": "+1 (999) 999-9999",
      "placeholder": "+1"
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      }
    },
    model: {
      value: (_vm.number),
      callback: function($$v) {
        _vm.number = $$v
      },
      expression: "number"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.number !== '' && ![10, 11].includes(this.number.replace(/[^0-9]/g, '').length)),
      expression: "this.number !== '' &&  ![10, 11].includes(this.number.replace(/[^0-9]/g, '').length)"
    }],
    staticClass: "red f7"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('login.alert', {
    alert: 'Please enter a valid phone number'
  })) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mv4"
  }, [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.pass', {
    pass: 'Password'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-reset ba border-login pa2 mb2 db w-100 br2",
    attrs: {
      "id": "password",
      "type": "password",
      "autocomplete": "current-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "mt2 color-theme no-underline inter",
    attrs: {
      "to": "/forgotpassword"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.getpass', {
    getpass: 'Click here to get a new password.'
  })))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb3"
  }, [_c('ak-button', {
    staticClass: "br3-ns",
    attrs: {
      "primary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login.log', {
    log: 'Log In'
  })))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb3 tc"
  }, [_c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "https://getakko.com/#sign-up",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('login.sign', {
    sign: "Don't have an account? Sign up now!"
  })) + "\n      ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c0cf6a9c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0cf6a9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1387
// module chunks = 0